import PageLayout from "@/components/layout/PageLayout";
import { createFileRoute } from "@tanstack/react-router";
import WalletManagerHeader from "./-components/WalletManagerHeader";
import WalletManagerSection from "./-components/WalletManagerSection";
import WalletSidebar from "./-components/WalletSidebar";
import { WalletSidebarProvider } from "./-providers/wallet-sidebar-provider";

export const Route = createFileRoute("/_main/wallets/")({
  head: () => ({
    meta: [{ title: "Reactor | Wallets" }],
  }),
  component: WalletsPage,
});

function WalletsPage() {
  return (
    <PageLayout header={<WalletManagerHeader />}>
      <WalletSidebarProvider>
        <div className="flex h-full w-full flex-col gap-1.5">
          <div className="flex h-full min-h-0 w-full flex-1 gap-1.5 xl:max-h-full">
            <WalletManagerSection />
            <WalletSidebar />
          </div>
        </div>
      </WalletSidebarProvider>
    </PageLayout>
  );
}
